import propTypes from 'prop-types';
import { Trans } from 'react-i18next';
import * as S from '../../styles';

/**
 * Frase traduzida que contém o e-mail de suporte como link.
 * A tradução guarda só a tag <supportLink>; o href pode ser informado
 * quando o mailto carrega assunto e corpo.
 */
const SupportEmailText = ({ i18nKey, email, href }) => (
  <Trans
    i18nKey={i18nKey}
    ns="calendar"
    values={{ email }}
    components={{
      supportLink: (
        <S.SupportLink href={href || `mailto:${email}`}>{email}</S.SupportLink>
      ),
    }}
  />
);

SupportEmailText.propTypes = {
  i18nKey: propTypes.string.isRequired,
  email: propTypes.string.isRequired,
  href: propTypes.string,
};

SupportEmailText.defaultProps = {
  href: '',
};

export default SupportEmailText;
